module.exports = __webpack_public_path__ + "img/cns_pc7.4cb3d15d.png";